import React, { useEffect, useRef, useState } from "react";
import { RiCheckDoubleLine } from "react-icons/ri";
import { FaUser, FaAngleLeft } from "react-icons/fa";
import { FaCirclePlus } from "react-icons/fa6";
import { LuBadgeInfo, LuSearch, LuDelete } from "react-icons/lu";
import { FiLock } from "react-icons/fi";
import { IoImagesOutline, IoClose } from "react-icons/io5";
import flag_2 from "./../../assets/img/tarh-parcham-iran-psdtarh2.png";
import MainLayout from "../../layout/main";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import { jalaliMonth, toDateString } from "../../helper/dateHelper";
import moment from "moment-jalali";
import { ApiEndpoints, useApiCall } from "../../api";
import { appRoutes, useAppNavigation } from "../../router/routes";
import _, { last } from "lodash";
import Loading from "../../component/loading";
import { useTableDataGenerator } from "../../helper/common";
import { HistoryItem } from "../../component/historyItem";
import { SelectOption } from "../../component/selectOption";
import { useAlert } from "react-alert";
import { FiTrash2 } from "react-icons/fi";
import { LuEye } from "react-icons/lu";
import { useValidation, ValidationTypes } from "../../helper/validation";
import { Input } from "../../component/input";
import { storageApi } from "../../storage/storageApi";
import { Table } from "../../component/table";
import { useLocation } from "react-router-dom";

const ProgramEditPage = () => {
  const { navigate, queryParameter, params } = useAppNavigation();

  const programId = params().id;
  const alert = useAlert();

  const [activeBox, setActiveBox] = useState(false);

  const [createReplyLoading, setCreateReplyLoading] = useState(false);

  const [tabnumber, setTabNumber] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  const onCHnageTab = (e) => {
    const id = e.target.id;
    if (id == 1) {
      setTabNumber(1);
    } else if (id == 2) {
      setTabNumber(2);
    }
  };

  const hideModal = () => {
    setShowModal(false);
  };

  const [[eventList], { loading: eventLoading }] = useApiCall({
    endpoints: ApiEndpoints.events.list,
  });
  const loc = useLocation();
  const [search, setSearch] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const { data } = useTableDataGenerator(eventList?.data ?? [], {
    filters: {
      title: search,
      month: selectedMonth,
    },
    pageSize: 1000,
  });

  useEffect(() => {
    if (!eventLoading) {
      const eventId = queryParameter().get("eventId")?.toString();
      setSelectedEvent(
        eventList?.data?.find((c) => c.id.toString() === eventId),
      );
    }
  }, [eventLoading]);

  const [selectedEvent, setSelectedEvent] = useState(null);

  const [
    [currentProgram],
    { loading: lastHistoryLoading, fetch: lastHistory },
  ] = useApiCall({
    endpoints: ApiEndpoints.program.lastHistory,
    payload: {
      programId,
    },
    lazy: true,
  });

  const [, { fetch: uploadImageApi }] = useApiCall({
    endpoints: ApiEndpoints.program.uploadImage,
    lazy: true,
  });

  const [, { fetch: answerQuestionApi }] = useApiCall({
    endpoints: ApiEndpoints.program.answerQuestion,
    lazy: true,
  });

  const [implementationDate, setImplementationDate] = useState(null);
  const [presenter, setPresenter] = useState(null);
  const [description, setDescription] = useState("");
  const [subject, setSubject] = useState([]);
  const [program, setProgram] = useState(null);
  const [reportDescription, setReportDescription] = useState("");
  const [executionsNumber, setExecutionsNumber] = useState("");
  const [selectedDay, setSelectedDay] = useState(null);

  const [reportImages, setReportImages] = useState([]);
  const [reportQuestions, setReportQuestions] = useState([]);
  const [status, setStatus] = useState("");

  const hasInfo = useRef({});
  const hasReport = useRef(false);

  // فراخوانی لیست‌ها قبل از اعتبارسنجی
  const [
    [programTypeList, subjectList, activityList, programNameList],
    { loading: formLoading },
  ] = useApiCall({
    endpoints: [
      ApiEndpoints.docs.programTypeList,
      ApiEndpoints.docs.subjectList,
      ApiEndpoints.docs.activityList,
      ApiEndpoints.docs.programNameList,
    ],
  });

  // بررسی وضعیت برنامه‌ی تبیینی
  const selectedProgramType = programTypeList?.data?.find(
    (c) => c.id === program?.barname_type
  );
  const isTabiini = selectedProgramType?.title === "تبیینی";

  const infoValidationOptions =
    reportDescription || executionsNumber
      ? [
          {
            name: "executionsNumber",
            label: "تعداد فعالیت های اجرا شده",
            value: executionsNumber,
            validations: [
              {
                type: ValidationTypes.stringRequired,
              },
            ],
          },
          {
            name: "reportDescription",
            label: "جزئیات اجرای برنامه",
            value: reportDescription,
            validations: [
              {
                type: ValidationTypes.stringRequired,
              },
              {
                type: ValidationTypes.stringMaxLength,
                options: {
                  length: 1400,
                },
              },
              {
                type: ValidationTypes.stringMinLength,
                options: {
                  length: 100,
                },
              },
            ],
          },
          {
            name: "reportImages",
            label: "عکس",
            value: reportImages,
            validations: [
              {
                type: ValidationTypes.arrayMaxLength,
                options: {
                  length: 3,
                },
              },
              {
                type: ValidationTypes.arrayMinLength,
                options: {
                  length: 1,
                },
              },
            ],
          },
          ...reportQuestions.map((c) => ({
            name: `question-${c.id}`,
            label: c.question,
            value: c.value,
            validations: [
              {
                type: ValidationTypes.stringMaxLength,
                options: {
                  length: 255,
                },
              },
            ],
          })),
        ]
      : [];

  const { errors, validate, removeError } = useValidation([
    {
      name: "program",
      label: "عنوان برنامه",
      value: program,
      validations: [
        {
          type: ValidationTypes.objectRequired,
        },
      ],
    },
    {
      name: "subject",
      label: "موضوع تبیینی",
      value: subject,
      // منطقِ هوشمند برای برنامه‌های تبیینی و تبلیغی
      validations: isTabiini ? [
        {
          type: ValidationTypes.arrayMaxLength,
          options: { length: 3 },
        },
        {
          type: ValidationTypes.arrayMinLength,
          options: { length: 1 },
          message: "برای برنامه‌های تبیینی، حداقل یک موضوع باید انتخاب شود",
        },
      ] : [
        {
          type: ValidationTypes.arrayMaxLength,
          options: { length: 3 },
        },
      ],
    },
    {
      name: "implementationDate",
      label: "تاریخ اجرا",
      value: implementationDate,
      validations: [
        {
          type: ValidationTypes.stringRequired,
        },
      ],
    },
    {
      name: "description",
      label: "جزئیات برنامه پیش بینی شده",
      value: description,
      validations: [
        {
          type: ValidationTypes.stringRequired,
        },
        {
          type: ValidationTypes.stringMaxLength,
          options: {
            length: 80,
          },
        },
        {
          type: ValidationTypes.stringMinLength,
          options: {
            length: 5,
          },
        },
      ],
    },
    {
      name: "presenter",
      label: "مجری برنامه",
      value: presenter,
      validations: [
        {
          type: ValidationTypes.stringRequired,
        },
        {
          type: ValidationTypes.stringMaxLength,
          options: {
            length: 30,
          },
        },
        {
          type: ValidationTypes.stringMinLength,
          options: {
            length: 5,
          },
        },
      ],
    },
    ...infoValidationOptions,
  ]);

  const replyProgramInfoPayload = {
    implementationDate: implementationDate
      ? moment(implementationDate).format("YYYY-MM-DD")
      : "",
    presenter,
    description,
    programType: program?.id,
    subjectList: subject ? subject.map((c) => c.id) : [],
    eventId: selectedEvent?.id,
  };

  const replyProgramReportPayload = {
    reportDescription,
    executionsNumber,
  };

  // حذف payload از اینجا برای جلوگیری از تله‌ی کلوژر
  const [, { loading: replyProgramLoading, fetch: replyProgram }] = useApiCall({
    endpoints: ApiEndpoints.program.reply,
    lazy: true,
  });

  const [, { fetch: fetchQuestion }] = useApiCall({
    endpoints: ApiEndpoints.program.questionList,
    lazy: true,
  });

  const [[history], { fetch: fetchHistory }] = useApiCall({
    endpoints: ApiEndpoints.program.history,
    payload: {
      programId,
    },
    lazy: true,
  });

  const updateProgramQuestions = async ({ id }) => {
    const [questionResponse] = await fetchQuestion({
      programNameId: id,
    });

    if (questionResponse?.data) {
      const newQuestionList = questionResponse?.data?.map((c) => ({
        ...c,
        value: "",
      }));
      newQuestionList.forEach((c) => removeError(`question-${c.id}`));
      setReportQuestions(newQuestionList);
    }
  };

  const loadImages = (src) => {
    return new Promise((res) => {
      const options = {
        headers: {
          authorization: `Bearer ${storageApi.getUserToken()}`,
        },
      };

      fetch(src, options)
        .then((res) => res.blob())
        .then((blob) => {
          res(URL.createObjectURL(blob));
        });
    });
  };

  useEffect(() => {
    const loadProgram = async () => {
      const [lastHistoryResponse] = await lastHistory();
      if (lastHistoryResponse.isOk) {
        setImplementationDate(
          moment(
            lastHistoryResponse.data.program_info.implementation_date,
            "YYYY-MM-DD",
          ).toDate(),
        );
        setSelectedDay({
          year: parseInt(
            moment(
              lastHistoryResponse.data.program_info.implementation_date,
              "YYYY-MM-DD",
            ).format("jYYYY"),
          ),
          month: parseInt(
            moment(
              lastHistoryResponse.data.program_info.implementation_date,
              "YYYY-MM-DD",
            ).format("jM"),
          ),
          day: parseInt(
            moment(
              lastHistoryResponse.data.program_info.implementation_date,
              "YYYY-MM-DD",
            ).format("jD"),
          ),
        });
        setPresenter(lastHistoryResponse.data.program_info.presenter);
        setDescription(lastHistoryResponse.data.program_info.description);
        setSelectedEvent(
          eventList?.data?.find(
            (c) => c.id === lastHistoryResponse.data.program_info.monasebat,
          ),
        );

        setSubject(
          subjectList?.data?.filter((c) =>
            lastHistoryResponse.data.program_info.mozooe_tabiyni.includes(c.id),
          ),
        );
        const currentProgram = programNameList?.data?.find(
          (c) => c.id === lastHistoryResponse.data.program_info.onvan_barnameh,
        );
        setProgram(currentProgram);
        setReportDescription(
          lastHistoryResponse.data.program_report?.description,
        );
        setExecutionsNumber(
          lastHistoryResponse.data.program_report?.executions_number,
        );

        setActiveBox(
          queryParameter().get("debug") ||
            lastHistoryResponse.data.can_add_report,
        );
        setStatus(lastHistoryResponse.data.status);
        const [questionResponse] = await fetchQuestion({
          programNameId: currentProgram?.id,
        });

        setReportImages(
          await Promise.all(
            (lastHistoryResponse.data.program_report?.images ?? []).map(
              async (s) => {
                const imageLoadedData = await loadImages(s.image);
                return {
                  ...s,
                  localSrc: imageLoadedData,
                };
              },
            ),
          ),
        );

        if (questionResponse?.data) {
          const answers =
            lastHistoryResponse.data.program_report?.answer_question ?? [];

          setReportQuestions(
            questionResponse?.data?.map((c) => ({
              ...c,
              value: answers.find((x) => x.question.id === c.id)?.answer ?? "",
            })),
          );
        }

        await fetchHistory();
        setPageLoading(false);
      }
    };
    if (
      !!programId &&
      !lastHistoryLoading &&
      !eventLoading &&
      !formLoading &&
      programNameList?.data?.length > 0
    ) {
      loadProgram();
    }
  }, [programId, eventLoading, formLoading]);

  useEffect(() => {
    if (!pageLoading) {
      if (queryParameter().get("report") === "1") {
        window.scroll({ top: 1000, behavior: "smooth" });
      }
    }
  }, [pageLoading]);

  const submitForm = async () => {
    const { isValid } = validate();
    if (!isValid) {
      return alert.error("لطفا خطا های فرم را برطرف کنید");
    }

    setCreateReplyLoading(true);
    hasInfo.current = !_.isEqual(replyProgramInfoPayload, {
      implementationDate: currentProgram.data.program_info.implementation_date,
      presenter: currentProgram.data.program_info.presenter,
      description: currentProgram.data.program_info.description,
      programType: currentProgram.data.program_info.onvan_barnameh,
      subjectList: currentProgram.data.program_info.mozooe_tabiyni,
      eventId: currentProgram.data.program_info.monasebat,
    });

    hasReport.current = !_.isEqual(replyProgramReportPayload, {
      executionsNumber: currentProgram.data.program_report?.executions_number,
      reportDescription: currentProgram.data.program_report?.description,
    });

    hasReport.current =
      hasReport.current || !!reportImages.find((c) => c.isNew);

    hasReport.current =
      hasReport.current || !!reportQuestions.find((c) => c.isNew);

    if (!hasInfo.current && !hasReport.current) {
      alert.error("مقادیر تغییری نداشته اند.");
      setCreateReplyLoading(false);
      return;
    }

    if (hasReport.current || hasInfo.current) {
      const uploadImageResponse = await Promise.all(
        reportImages
          .filter((c) => c.isNew)
          .map(async (c) => {
            const [res] = await uploadImageApi({
              file: c.file,
            });
            return res.data;
          }),
      );

      const answerQuestionResponse = await Promise.all(
        reportQuestions
          .filter((c) => c.value)
          .map(async (c) => {
            const [res] = await answerQuestionApi({
              answer: c.value,
              questionId: c.id,
            });
            return res.data;
          }),
      );

      // ساخت پِیلود کاملاً داینامیک برای پرهیز از تله‌ی کلوژر
      const dynamicPayload = {
        programId,
        ...replyProgramInfoPayload,
        ...replyProgramReportPayload,
        hasReport: hasReport.current,
        hasInfo: hasInfo.current,
        reportImages: [
          ...uploadImageResponse.map((c) => c.id),
          ...reportImages.filter((c) => !c.isNew).map((c) => c.id),
        ],
        reportQuestions: answerQuestionResponse.map((c) => c.id),
      };

      const [replyResult] = await replyProgram(dynamicPayload);
      setCreateReplyLoading(false);

      if (replyResult.isOk) {
        navigate(appRoutes.programList({}));
      }
    } else {
      setCreateReplyLoading(false);
    }
  };

  const onAddImage = (e) => {
    removeError("reportImages");
    if (e.target.files && e.target.files.length > 0) {
      for (const files of e.target.files) {
        const reader = new FileReader();
        reader.onload = function (e) {
          if (files.size > 1048576 * 1.5) {
            alert.error("حجم فایل باید کمتر از ۱.۵ مگ باشد");
            return;
          }
          setReportImages((i) => [
            ...i,
            { localSrc: e.target.result, isNew: true, file: files },
          ]);
        };
        reader.readAsDataURL(files);
      }
    }
  };

  const onChangeModal = () => {
    setShowModal(true);
  };

  const [previewImages, setPreviewImages] = useState(null);

  if (pageLoading) {
    return (
      <MainLayout>
        <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full  shadow-sm w-full">
          <Loading color={"blue"} isLoading={true} center />
        </div>
      </MainLayout>
    );
  }

  const FileWrapper = ({ children }) => {
    if (activeBox) {
      return <label htmlFor="file">{children}</label>;
    }
    return <div>{children}</div>;
  };

  return (
    <MainLayout>
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full  shadow-sm w-full">
        {/* sec1 */}
        <div className="sec1 w-full bg-greenblue-light h-auto rounded-3xl relative p-8">
          <img src={flag_2} className=" absolute left-0 top-0 h-32" />
          <div className="flex flex-col gap-8 justify-center items-center w-[60%] mx-auto">
            <div>
              <div className="md:text-3xl text-xl text-center font-bold mb-6">
                <span> ویرایش </span>
                <span className=" text-greenblue">برنامه</span>
              </div>
              {selectedEvent && (
                <p className="text-center">
                  مناسبت :<span> {selectedEvent?.title} </span>
                  <span className={"opacity-80 mx-2"}>|</span>
                  تاریخ :
                  <span>
                    {" "}
                    {toDateString(selectedEvent?.date, "jYYYY/jMM/jDD")}{" "}
                  </span>
                </p>
              )}
              <Loading isLoading={formLoading}></Loading>
            </div>
          </div>
        </div>

        {/* sec 2 -> tab */}
        <div className="flex justify-center items-center cursor-pointer">
          <div className=" bg-gray-200 rounded-xl md:gap-4 gap-0 p-2 flex justify-center items-center">
            <div
              className={`md:px-8 px-3 md:py-3 py-2 rounded-lg ${tabnumber === 1 ? "shadow-lg bg-white text-gray-800" : "bg-transparent  text-gray-600"}  md:min-w-[200px]  text-center `}
              onClick={onCHnageTab}
              id="1"
            >
              ویرایش برنامه و گزارش
            </div>
            <div
              onClick={onCHnageTab}
              className={`md:px-8 px-3 md:py-3 py-2 rounded-lg ${tabnumber === 2 ? "shadow-lg bg-white text-gray-800" : "bg-transparent  text-gray-600"}    md:min-w-[200px] w-[100px] text-center `}
              id="2"
            >
              {" "}
              تاریخچه{" "}
            </div>
          </div>
        </div>
        {currentProgram?.data?.reply_admin && (
          <div
            className={`text-white text-sm rounded-xl p-4 w-full max-w-[900px] mx-auto ${currentProgram?.data?.reply_admin?.program_status === "تایید شده" ? "bg-green-600" : "bg-red-600"}`}
          >
            <div className="flex justify-start gap-2 mb-4">
              <FaUser />
              <span> اخرین پاسخ ناظر </span>
            </div>
            <p className="mb-2">
              <b>وضعیت: </b>
              {currentProgram?.data?.reply_admin?.program_status}
            </p>
            {currentProgram?.data?.reply_admin?.description && (
              <p>
                <b>توضیحات: </b>
                {currentProgram?.data?.reply_admin?.description}
              </p>
            )}
          </div>
        )}
        {/* sec 3 */}

        {tabnumber === 1 ? (
          <>
            <div className="w-full max-w-[900px] mx-auto bg-gray-200 bg-opacity-90 border-2 border-gray-300 rounded-xl md:p-8 p-4">
              <div className="flex justify-between items-start">
                <div className={"font-bold"}>
                  {" "}
                  اطلاعات برنامه پیش بینی شده:{" "}
                </div>
                <button
                  className=" bg-yellow-600 text-white rounded-lg md:px-6 px-3 md:text-base text-sm py-2"
                  onClick={onChangeModal}
                >
                  {" "}
                  تغییر مناسبت{" "}
                </button>
              </div>
              {/* form */}
              <div className="grid md:grid-cols-2 grid-cols-1 gap-8 mt-6">
                <div className="form-field w-full relative">
                  <SelectOption
                    label={"عنوان برنامه"}
                    error={errors["program"]}
                    value={program?.id}
                    options={programNameList?.data?.map((c) => ({
                      label: c.title,
                      value: c.id,
                    }))}
                    onChange={(e) => {
                      removeError("program");
                      setProgram(
                        programNameList?.data?.find((c) => c.id === e.value),
                      );
                      updateProgramQuestions(
                        programNameList?.data?.find((c) => c.id === e.value),
                      );
                      setSubject([]);
                    }}
                  />
                </div>
                <div className="form-field w-full relative">
                  <SelectOption
                    label={"حوزه فعالیت"}
                    value={
                      activityList?.data?.find(
                        (c) => c.id === program?.hoze_faaliat,
                      )?.id
                    }
                    options={activityList?.data?.map((c) => ({
                      label: c.title,
                      value: c.id,
                    }))}
                    onChange={(e) => {
                      setProgram(
                        programNameList?.data?.find((c) => c.id === e.value),
                      );
                    }}
                    disabled={true}
                  />
                </div>
                <div className="form-field w-full relative">
                  <SelectOption
                    label={"نوع برنامه"}
                    value={
                      programTypeList?.data?.find(
                        (c) => c.id === program?.barname_type,
                      )?.id
                    }
                    options={programTypeList?.data?.map((c) => ({
                      label: c.title,
                      value: c.id,
                    }))}
                    onChange={(e) => {
                      setProgram(
                        programNameList?.data?.find((c) => c.id === e.value),
                      );
                    }}
                    disabled={true}
                  />
                </div>
                <div className="form-field w-full relative">
                  <SelectOption
                    label={"موضوع تبیینی"}
                    value={subject?.map((c) => c.id)}
                    max={3}
                    options={subjectList?.data
                      ?.filter((c) => c.barname_type === program?.barname_type)
                      ?.map((c) => ({
                        label: c.title,
                        value: c.id,
                      }))}
                    error={errors["subject"]}
                    onChange={(e) => {
                      removeError("subject");
                      setSubject(
                        subjectList?.data?.filter((c) =>
                          e.find((x) => x.value === c.id),
                        ),
                      );
                    }}
                    isMulti
                    info={"حداقل ۱ و حداکثر ۳ مورد باید انتخاب شود"}
                  />
                </div>
                <div className="form-field w-full relative">
                  <span className=" px-3 text-[12px] right-2"> زمان اجرا </span>
                  <div
                    className={`rounded-lg p-4 border-[1px] bg-white border-gray-100 w-full text-sm pl-8 ${errors["implementationDate"] ? "date-picker-input-error" : ""}`}
                  >
                    <DatePicker
                      inputClassName={"date-picker-input"}
                      locale={"fa"}
                      value={selectedDay}
                      onChange={(date) => {
                        setSelectedDay(date);
                        const { day, month, year } = date;
                        setImplementationDate(
                          moment(
                            `${year}/${month}/${day}`,
                            "jYYYY/jM/jD",
                          ).toDate(),
                        );
                        removeError("implementationDate");
                      }}
                      inputPlaceholder={"انتخاب زمان اجرا"}
                      minimumDate={
                        selectedEvent &&
                        (selectedEvent.date_limit_in_use_once_a_year
                          ? {
                              year: parseInt(
                                moment(selectedEvent?.date)
                                  .add("d", -5)
                                  .format("jYYYY"),
                              ),
                              month: parseInt(
                                moment(selectedEvent?.date)
                                  .add("d", -5)
                                  .format("jM"),
                              ),
                              day: parseInt(
                                moment(selectedEvent?.date)
                                  .add("d", -5)
                                  .format("jD"),
                              ),
                            }
                          : {
                              year: parseInt(
                                moment(selectedEvent?.date)
                                  .add("d", -5)
                                  .format("jYYYY"),
                              ),
                              month: 1,
                              day: 1,
                            })
                      }
                      maximumDate={
                        selectedEvent &&
                        (selectedEvent.date_limit_in_use_once_a_year
                          ? {
                              year: parseInt(
                                moment(selectedEvent?.date)
                                  .add("d", 5)
                                  .format("jYYYY"),
                              ),
                              month: parseInt(
                                moment(selectedEvent?.date)
                                  .add("d", 5)
                                  .format("jM"),
                              ),
                              day: parseInt(
                                moment(selectedEvent?.date)
                                  .add("d", 5)
                                  .format("jD"),
                              ),
                            }
                          : {
                              year: parseInt(
                                moment(selectedEvent?.date)
                                  .add("d", 5)
                                  .format("jYYYY"),
                              ),
                              month: 12,
                              day: 30,
                            })
                      }
                    />
                  </div>
                  {errors["implementationDate"] && (
                    <p className={"text-sm mt-2 text-red-600"}>
                      {errors["implementationDate"]}
                    </p>
                  )}
                </div>
                <div className="form-field w-full relative">
                  <span className="px-3 text-[12px] right-2">
                    {" "}
                    مجری برنامه{" "}
                  </span>

                  <Input
                    type="text"
                    value={presenter}
                    placeholder="مجری برنامه"
                    error={errors["presenter"]}
                    className=" rounded-lg p-4 border-[1.5px] border-gray-100 w-full text-sm pl-8"
                    onChange={(e) => {
                      removeError("presenter");
                      setPresenter(e);
                    }}
                    maxLength={30}
                  />
                </div>
              </div>
              <div className="mt-8">
                <div className="form-field w-full relative">
                  <span className="px-3 text-[12px] right-2">
                    جزئیات برنامه پیش بینی شده
                  </span>
                  <Input
                    error={errors["description"]}
                    type="text"
                    placeholder="جزئیات برنامه پیش بینی شده"
                    value={description}
                    maxLength={80}
                    onChange={(e) => {
                      setDescription(e);
                      removeError("description");
                    }}
                  ></Input>
                  <span className="px-3 text-[12px] right-2">
                    تعداد کاراکتر: {description.length} / 80
                  </span>
                </div>
              </div>

              <div className="mt-8 flex justify-center">
                {!activeBox && (
                  <button
                    onClick={submitForm}
                    className="md:w-[40%] w-full py-4 text-white bg-blue-500  flex justify-center gap-2 rounded-lg"
                  >
                    <RiCheckDoubleLine size={24} />
                    <span>ذخیره ویرایش و ارسال</span>
                    <Loading isLoading={createReplyLoading} />
                  </button>
                )}
              </div>
            </div>

            {/* sec 4 */}
            <div className=" bg-green2 gap-4 max-w-[900px] w-full mx-auto rounded-lg p-4 py-2 flex items-center text-white">
              <LuBadgeInfo size={62} />
              <p className="text-sm">
                فعال محترم ؛ برنامه فوق به عنوان برنامه ی پیش بینی شده خواهد
                بود.
                <span className="font-bold text-purple-800">
                  بخش زیرین ( ثبت گزارش)
                </span>
                بعد از تاریخ اجرای برنامه فعال و امکان ثبت گزارش خواهد داشت . در
                صورت تایید ناظر ، امتیاز گزارش برنامه، منظور خواهد شد. در صورت
                اجرا نشدن برنامه پیش بینی شده ، لطفا آن را حذف نمایید.
              </p>
            </div>

            {/* sec 5 -> form general */}
            <div
              className={`w-full max-w-[900px] mx-auto bg-gray-200 bg-opacity-90 border-2 border-gray-300 rounded-xl md:p-8 p-4 ${activeBox ? "opacity-100" : "opacity-40"} `}
            >
              <div className="flex justify-between items-start">
                <div className={"font-bold"}>اطلاعات گزارش اجرا :</div>
                {!activeBox && (
                  <div className="p-2 text-gray-500">
                    <FiLock size={32} />
                  </div>
                )}
              </div>
              {/* form */}
              <div className="md:grid grid-cols-5 space-y-3 gap-8 mt-6 items-start">
                <div className=" col-span-3">
                  <div className="">
                    <div className="form-field w-full relative">
                      <span className="px-3 text-[12px] right-2">
                        جزئیات اجرای گزارش
                      </span>
                      <textarea
                        type="text"
                        placeholder="جزئیات اجرای گزارش"
                        className={`rounded-lg p-4 border-[1.5px] border-gray-100 w-full text-sm pl-8 ${errors["description"] ? "border-red-600" : ""}`}
                        rows="5"
                        minLength={100}
                        maxLength={1400}
                        disabled={!activeBox}
                        value={reportDescription}
                        onChange={(e) => {
                          setReportDescription(e.target.value);
                          removeError("reportDescription");
                        }}
                      ></textarea>
                      <span className="px-3 text-[12px] right-2">
                        تعداد کاراکتر:
                        {reportDescription?.length ?? 0} / 1400
                      </span>
                      <span className="px-3 text-[12px] right-2">
                        حداقل کاراکتر مورد قبول : ۱۰۰ کاراکتر
                      </span>
                      {errors["reportDescription"] && (
                        <p className={"text-sm mt-2 text-red-600"}>
                          {errors["reportDescription"]}
                        </p>
                      )}

                      <div className="form-field w-full relative">
                        <Input
                          label={"تعداد فعالیت های اجرا شده"}
                          error={errors["executionsNumber"]}
                          type="number"
                          disabled={!activeBox}
                          placeholder="تعداد فعالیت های اجرا شده"
                          className=" rounded-lg p-4 border-[1.5px] border-gray-100 w-full text-sm pl-8"
                          value={executionsNumber}
                          onChange={(e) => {
                            if (e >= 0) {
                              setExecutionsNumber(e);
                              removeError("executionsNumber");
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="relative mt-4">
                      <input
                        id="file"
                        type="file"
                        hidden
                        onChange={onAddImage}
                      />
                      <div className={"flex gap-4"}>
                        {reportDescription && executionsNumber ? (
                          reportImages.length <= 2 && (
                            <FileWrapper>
                              <div className="flex cursor-pointer flex-col justify-center items-center w-32 h-28 border-gray-300 border-dashed border-2 rounded-xl bg-gray-100">
                                <IoImagesOutline
                                  size={24}
                                  className="text-gray-400"
                                />
                                <span className="text-sm"> افزودن تصویر </span>
                                <FaCirclePlus
                                  className=" text-green-500"
                                  size={20}
                                />
                              </div>
                            </FileWrapper>
                          )
                        ) : (
                          <div className="flex flex-col justify-center items-center w-32 h-28 border-gray-200 border-dashed border-2 rounded-xl bg-gray-100">
                            <IoImagesOutline
                              size={24}
                              className="text-gray-300"
                            />
                            <span className="text-sm text-gray-300">
                              {" "}
                              افزودن تصویر{" "}
                            </span>
                            <FaCirclePlus
                              className=" text-gray-300"
                              size={20}
                            />
                          </div>
                        )}

                        {reportImages.map((c, index) => (
                          <div
                            className={
                              "flex flex-col justify-center items-center"
                            }
                          >
                            <div className="flex justify-center items-center min-w-32 min-h-28 border-gray-300 border-dashed border-2 rounded-xl bg-gray-100">
                              <img
                                className="h-[105px] w-[105px] object-cover object-center"
                                src={c.localSrc || c.image}
                              />
                            </div>
                            {activeBox && (
                              <div className={"mt-2 flex justify-center gap-3"}>
                                <FiTrash2
                                  onClick={() =>
                                    setReportImages((images) =>
                                      images.filter((_, i) => i !== index),
                                    )
                                  }
                                  size={16}
                                  className="text-red-500 cursor-pointer hover:text-red-700"
                                />
                                <LuEye
                                  onClick={() => setPreviewImages(c)}
                                  size={16}
                                  className="text-blue-500 cursor-pointer hover:text-blue-700"
                                />
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                      {!(reportDescription && executionsNumber) && (
                        <p className="text-md text-gray-500 mt-2">
                          بعد از تکمیل فیلدهای گزارش امکان بارگذاری تصویر فعال
                          می‌گردد.
                        </p>
                      )}
                      {errors["reportImages"] ? (
                        <p
                          className={"text-sm mt-2 text-red-600 cursor-pointer"}
                        >
                          {errors["reportImages"]}
                        </p>
                      ) : (
                        <p className={"text-sm mt-2"}>
                          حداقل 1 و حداکثر 3 عکس با پسوند jpg یا jpeg و حجم
                          حداکثر 1.5 مگابایت بارگیری شود.
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="md:col-span-2 col-span-1 border-2 border-gray-200 rounded-xl bg-gray-100 p-4 flex flex-col gap-4 ">
                  {reportDescription && executionsNumber ? (
                    reportQuestions.map((c) => {
                      return (
                        <div className="form-field w-full relative">
                          <Input
                            label={c.question}
                            error={errors[`question-${c.id}`]}
                            type="text"
                            disabled={!activeBox}
                            placeholder={c.question}
                            className=" rounded-lg p-4 border-[1.5px] border-gray-100 w-full text-sm pl-8"
                            value={c.value}
                            onChange={(e) => {
                              removeError(`question-${c.id}`);
                              setReportQuestions((qa) =>
                                qa.map((q) => {
                                  if (q.id === c.id) {
                                    return {
                                      ...q,
                                      value: e,
                                      isNew: true,
                                    };
                                  }
                                  return q;
                                }),
                              );
                            }}
                          />
                        </div>
                      );
                    })
                  ) : (
                    <>
                      <p className="text-xs text-gray-600">
                        بعد از تکمیل فیلدهای گزارش موارد زیر فعال می‌گردد:{" "}
                      </p>{" "}
                      {reportQuestions.map((c) => {
                        return (
                          <div className="form-field w-full relative">
                            <Input
                              label={c.question}
                              error={errors[`question-${c.id}`]}
                              type="text"
                              disabled={true}
                              disabledLabel={true}
                              placeholder={c.question}
                              className=" rounded-lg p-4 border-[1.5px] border-gray-100 w-full text-sm pl-8"
                              value={c.value}
                              onChange={(e) => {
                                removeError(`question-${c.id}`);
                                setReportQuestions((qa) =>
                                  qa.map((q) => {
                                    if (q.id === c.id) {
                                      return {
                                        ...q,
                                        value: e,
                                        isNew: true,
                                      };
                                    }
                                    return q;
                                  }),
                                );
                              }}
                            />
                          </div>
                        );
                      })}
                    </>
                  )}

                  <div className="text-left mt-4">
                    امتیاز برنامه :<span> {program?.score} </span>
                  </div>
                </div>
              </div>

              <div className="mt-8 flex justify-center w-full">
                {currentProgram?.data?.reply_admin?.program_status ===
                "تایید شده"
                  ? activeBox && (
                      <button
                        disabled={true}
                        className="md:w-[40%] w-full py-4 text-slate-600 bg-green-100  flex justify-center gap-2 rounded-lg"
                      >
                        <RiCheckDoubleLine size={24} />
                        <span>این برنامه تایید شده است.</span>
                        <Loading isLoading={createReplyLoading} />
                      </button>
                    )
                  : activeBox && (
                      <button
                        disabled={_.isEqual(replyProgramInfoPayload)}
                        onClick={submitForm}
                        className="md:w-[40%] w-full py-4 text-white bg-blue-500 hover:bg-blue-600 flex justify-center gap-2 rounded-lg"
                      >
                        <RiCheckDoubleLine size={24} />
                        <span>ذخیره ویرایش و ارسال</span>
                        <Loading isLoading={createReplyLoading} />
                      </button>
                    )}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="w-full max-w-[900px] mx-auto space-y-8">
              {history?.data?.map((item, index) => {
                return (
                  <HistoryItem
                    key={index}
                    {...item}
                    programTypeList={programTypeList?.data ?? []}
                    subjectList={subjectList?.data ?? []}
                    activityList={activityList?.data ?? []}
                    programNameList={programNameList?.data ?? []}
                  />
                );
              })}
            </div>
          </>
        )}
      </div>

      {showModal && (
        <div
          className={`z-[10000] bg-gray-900 bg-opacity-40 w-screen h-screen fixed top-0 left-0 overflow-y-scroll`}
        >
          <div className="md:w-[1200px] w-[350px] max-h-[600px] rounded-xl overflow-y-scroll p-8 bg-white absolute top-[50%] -translate-y-[50%] left-[50%] -translate-x-[50%]">
            <div className=" text-center text-lg font-semibold mb-4">
              <div
                className=" absolute left-6 top-6 z-40 p-2 text-gray-500"
                onClick={hideModal}
              >
                <IoClose size={24} />
              </div>
              ویرایش مناسبت
            </div>
            <div className="flex md:flex-row flex-col gap-4 mt-4 mb-4">
              <div className="form-feild relative">
                <input
                  type="text"
                  placeholder="جستجو عنوان"
                  className=" rounded-lg p-2 pr-8 border-[1.5px] border-gray-100 w-full text-sm pl-12"
                  onChange={(e) => setSearch(e.target.value)}
                />
                <LuSearch
                  className="absolute right-2 top-[50%] text-gray-300 -translate-y-[50%]"
                  size={20}
                />
              </div>
              <div className="form-feild relative">
                <select
                  type="text"
                  placeholder="شماره یک"
                  className=" rounded-lg w-40 p-2 pr-8 border-[1.5px] border-gray-100 text-sm"
                  onChange={(e) => setSelectedMonth(e.target.value)}
                >
                  <option name="month" value="">
                    انتخاب نشده
                  </option>
                  {jalaliMonth.map((c) => (
                    <option name={"month"} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <Table
              containerClassName={"max-h-[600px] overflow-y-scroll"}
              data={data}
              header={[
                {
                  name: "ردیف",
                  width: 2,
                  render: (i) => i.rowIndex,
                },
                {
                  name: "عنوان مناسبت",
                  width: 4,
                  render: (i) => i.title,
                },
                {
                  name: "تاریخ مناسبت",
                  width: 3,
                  render: (i) => toDateString(i.date, "jYYYY/jMM/jDD"),
                },
                {
                  name: "عملیات",
                  width: 2,
                  render: (i) =>
                    i.id.toString() === selectedEvent?.id?.toString() ? (
                      "انتخاب شده"
                    ) : (
                      <button
                        onClick={() => {
                          setSelectedEvent(i);
                          setSelectedDay(null);
                          setImplementationDate("");
                          removeError("selectedEvent");
                          setShowModal(false);
                        }}
                        className="flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
                      >
                        انتخاب
                        <FaAngleLeft />
                      </button>
                    ),
                },
              ]}
            />
          </div>
        </div>
      )}

      {previewImages && (
        <div
          className={` bg-gray-900 bg-opacity-40 w-screen h-screen fixed top-0 left-0 `}
        >
          <div className="md:w-[750px] w-[450px] md:h-[750px] rounded-xl p-8 bg-white absolute top-[50%] -translate-y-[50%] left-[50%] -translate-x-[50%] overflow-y-scroll">
            <div className=" text-center text-lg font-semibold mb-4 mt-4">
              <div
                className=" absolute left-6 top-6 z-40 p-2 text-gray-500"
                onClick={() => setPreviewImages(null)}
              >
                <IoClose size={24} />
              </div>
            </div>
            <div className={"flex justify-center items-center"}>
              <img
                className={"mt-10 flex mb-10 h-auto max-w-full"}
                src={previewImages.localSrc || previewImages.image}
              />
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default ProgramEditPage;